import {Component, OnInit, output} from '@angular/core';
import {Store} from '@ngrx/store';

import * as ProfileActions from './../store/profile.actions';
import * as fromProfile from './../store/profile.reducers';
import * as fromApp from '../../store/app.reducers';
import {Observable} from 'rxjs';
import {Profile} from '../profile.model';

@Component({
    selector: 'app-profile-autocomplete',
    templateUrl: './profile-autocomplete.component.html',
    styleUrls: ['./profile-autocomplete.component.scss'],
    standalone: false
})
export class ProfileAutocompleteComponent implements OnInit {

  profileState: Observable<fromProfile.State>;
  show: boolean;
  readonly selectProfile = output<Profile>();
  readonly clearProfile = output<Profile>();
  selectedProfile: Profile;

  constructor(
    private store: Store<fromApp.AppState>,
  ) { }

  ngOnInit() {
    this.show = false;
    this.profileState = this.store.select('profile');
  }

  searchProfile($event) {
    this.show = true;
    this.store.dispatch(
      new ProfileActions.GetAuditsAutocomplete({
        params: {
          profile: $event,
          limit: 10
        }
      })
    );
  }

  onSelectProfile(profile: Profile) {
    this.selectProfile.emit(profile);
    this.show = false;
    this.selectedProfile = profile;
  }

}
